export { LTPromo } from './Promo';
